import {
  START_LOADING,
  CREATED_POSTING,
  RESET_DATA,
  CLEAR_NOMINAL_JOURNAL_POSTING,
  ADD_OFFICE_CREDIT_MATTER_LIST,
  REMOVE_OFFICE_CREDIT_MATTER_LIST,
} from "../types/index";
import * as api from "../api/index.js";
import { handleApiError } from "Helper";

export const resetdata = () => async (dispatch) => {
  dispatch({ type: RESET_DATA });
};

export const createJournalPosting = (data) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const datas = await api.createpostingJournal(data);
    dispatch({ type: CREATED_POSTING, payload: datas });
  } catch (error) {
    handleApiError(error);
  }
};

export const clearNominalFields = (value) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    dispatch({ type: CLEAR_NOMINAL_JOURNAL_POSTING, payload: value });
  } catch (error) {
    handleApiError(error);
  }
};

export const getOfficeCreditMatterList = (data) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const datas = await api.getUnpaidMatterList(data);
    dispatch({ type: ADD_OFFICE_CREDIT_MATTER_LIST, payload: datas.data.data });
  } catch (error) {
    handleApiError(error);
  }
};

export const removeOfficeCreditMatterList = () => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    dispatch({ type: REMOVE_OFFICE_CREDIT_MATTER_LIST });
  } catch (error) {
    handleApiError(error);
  }
};
